import { render } from "./receiveManage.vue?vue&type=template&id=2ac531c2&scoped=true"
import script from "./receiveManage.vue?vue&type=script&lang=js"
export * from "./receiveManage.vue?vue&type=script&lang=js"

import "./receiveManage.vue?vue&type=style&index=0&id=2ac531c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ac531c2"

export default script